/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Maintainer_SourceInputs */

const en_contact_maintainer_source = /** @type {(inputs: Contact_Maintainer_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source code`)
};

const ko_contact_maintainer_source = /** @type {(inputs: Contact_Maintainer_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소스 코드`)
};

const ja_contact_maintainer_source = /** @type {(inputs: Contact_Maintainer_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースコード`)
};

/**
* | output |
* | --- |
* | "Source code" |
*
* @param {Contact_Maintainer_SourceInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_maintainer_source = /** @type {((inputs?: Contact_Maintainer_SourceInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Maintainer_SourceInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_maintainer_source(inputs)
	if (locale === "ko") return ko_contact_maintainer_source(inputs)
	return ja_contact_maintainer_source(inputs)
});